import { IEndereco } from "app/types/IEndereco";
import globalMU from "globalMU";
import React from "react";
import { AbaEnderecos } from "./AbaEnderecosCliente";

export type AbaEnderecosContainerProps = {
    enderecos: IEndereco[];
    enderecosSelecionados: IEndereco[];
    ativarEditarEndereco: (ativar: boolean, endereco: IEndereco) => void
    excluirEnderecosTemporarios: (enderecos: IEndereco[]) => void;
    onToggleEnderecoSelecionado: (enderecos: IEndereco) => void;
    permitirIncluirEndereco: boolean
    permitirExcluirEndereco: boolean
    permitirEditarEndereco: boolean
    somenteLeitura: boolean
    habilitarExcluirEndereco: boolean
    tipoPessoa: string // 441453
}

export const AbaEnderecosContainer = (props: AbaEnderecosContainerProps) => {
    return (
        <>
            <AbaEnderecos
                somenteLeitura={props.somenteLeitura}
                enderecos={props.enderecos}
                tipoPessoa={props.tipoPessoa}
                habilitarExcluirEndereco={props.habilitarExcluirEndereco}
                enderecosSelecionados={props.enderecosSelecionados}
                exibirBotaoEditarEndereco={props.permitirEditarEndereco}
                exibirBotaoIncluirEndereco={props.permitirIncluirEndereco}
                exibirBotaoExcluirEndereco={props.permitirExcluirEndereco}
                onIncluirEndereco={() => props.ativarEditarEndereco(true, null)}
                onExcluirEndereco={props.excluirEnderecosTemporarios}
                onEditarEndereco={(endereco) => props.ativarEditarEndereco(true, endereco)}
                corSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                textoSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                onToggleEnderecoSelecionado={props.onToggleEnderecoSelecionado}
            />
        </>
    )
}